module.exports = __webpack_public_path__ + "static/media/exelist-image@2x.c1079c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exelist-image@2x.png
// module id = 1265
// module chunks = 1